/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSelectEntityModalStyles = makeStyles(theme => ({
  modalPaper: {
    height: '100%',
    maxHeight: '640px',
  },
  body: {
    padding: '0 10px',
    height: '100%',
  },
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    height: '100%',
  },
  row2Columns: {},
  row3Columns: {},
  column: {
    flex: '0 0 auto',
    width: '100%',
    paddingRight: '10px',
    paddingLeft: '10px',
    overflowY: 'auto',
    '&:not(:first-child)': {
      borderLeft: '1px solid #F1F2F3',
    },
    '$row2Columns &': {
      width: 'calc(100% / 2)',
    },
    '$row3Columns &': {
      width: 'calc(100% / 3)',
    },
  },
  tipText: {
    color: '#A2A7AE',
    fontSize: '16px',
    lineHeight: '20px',
  },

  root: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  rootButton: {
    justifyContent: 'space-between',
    paddingLeft: '15px',
    paddingRight: '12px',
    width: '240px',
  },
  rootButtonIcon: {
    transform: 'rotate(-90deg)',
    marginLeft: '10px',
  },
  rootInfo: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    fontSize: '16px',
    lineHeight: '20px',
    marginLeft: '16px',
    flexWrap: 'wrap',
    '& > *:not(:last-child):after': {
      content: "'/'",
      padding: '0 5px',
    },
    '& > *:last-child': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  loaderMl: {
    marginLeft: '10px',
  },
}));
